import {Injectable} from '@angular/core';

import {BaseD3Selection} from '../d3/d3.interface';
import {D3Service} from '../d3/d3.service';
import {TRANSITION_DURATION} from '../d3/d3.util';
import {RmnD3TreeData} from '../models/rmn-d3-tree-data.interface';

@Injectable()
export class ImpactAssessmentTreeService extends D3Service<RmnD3TreeData> {
  protected appendNodeLabel(enterSelection: BaseD3Selection<RmnD3TreeData>): void {
    const textSelection = this.appendNodeLabelPlaceholder(enterSelection);

    this.appendNodeTypeText(textSelection);
    this.appendNodeNameText(textSelection);
  }

  private appendNodeTypeText(textSelection: BaseD3Selection<RmnD3TreeData>): void {
    textSelection
      .append('tspan')
      .classed('node-type', true)
      .attr('y', d => (d.data.name ? '-.4em' : '.4em'))
      .transition()
      .delay(TRANSITION_DURATION / 2)
      .text(d => {
        return d.data.name
          ? this.clipText(d.data.type)
          : this.clipText(d.data.type) + ` (${d.data.count})`;
      });
  }

  private appendNodeNameText(textSelection: BaseD3Selection<RmnD3TreeData>): void {
    const isMainParent = d => !d.parent;
    textSelection
      .append('tspan')
      .classed('node-title', true)
      .attr('x', d => (isMainParent(d) ? -13 : 13))
      .attr('y', d => (d.data.type ? '1em' : '.4em'))
      .transition()
      .delay(TRANSITION_DURATION / 2)
      .text(d => this.clipText(d.data.name));
  }
}
